import { useCallback } from 'react';

import { useSelector } from 'react-redux';

import { DEVICE_TYPE } from 'config/api';

import {
    selectAppSessionId,
    selectVideoSessionId,
} from 'store/session/selectors';

import { ReturnToLauncherUavParams, UavEvents } from './types';
import useGetBaseUavParams from './useGetBaseUavParams';
import { MOBILE_PLAYBACK_CONTENT_SOURCE } from './utils';

export default function useGetReturnToLauncherParams() {
    const appSessionId = useSelector(selectAppSessionId);
    const sessionId = useSelector(selectVideoSessionId);

    const getBaseUavParams = useGetBaseUavParams();

    const getReturnToLauncherParams = useCallback(
        (appName?: string): ReturnToLauncherUavParams | undefined => {
            const baseUavParams = getBaseUavParams(
                UavEvents.RETURN_TO_LAUNCHER,
            );

            if (baseUavParams) {
                return {
                    ...baseUavParams,
                    metadata: {
                        contentSource: MOBILE_PLAYBACK_CONTENT_SOURCE,
                        contentType: 'live-stcu-event',
                        appSessionId,
                        playbackSessionId: sessionId,
                        appVersion: baseUavParams.metadata.appVersion,
                        appName: appName || baseUavParams.metadata.appName,
                        deviceType: DEVICE_TYPE,
                    },
                };
            }

            return undefined;
        },
        [getBaseUavParams, appSessionId, sessionId],
    );

    return {
        getReturnToLauncherParams,
    };
}
